export default __webpack_public_path__ + "static/media/002-boab tree.cde17a24.svg";